import { render, staticRenderFns } from "./OrderDataPreviewsDialog.vue?vue&type=template&id=a8d8c83a&"
import script from "./OrderDataPreviewsDialog.vue?vue&type=script&lang=js&"
export * from "./OrderDataPreviewsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCarousel,VCarouselItem,VDialog})
